// Effective date of the Privacy Policy (YYYY-MM-DD). Update when the policy
// changes. Can be overridden without editing code through the
// REACT_APP_PRIVACY_EFFECTIVE_DATE environment variable, either at runtime
// (window.env, see env-config.template.js) or at build time.
export const DEFAULT_PRIVACY_EFFECTIVE_DATE = '2026-09-26';

export const PRIVACY_CONTACT_EMAIL = 'admin@nosi.io';

const isValidDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && !Number.isNaN(Date.parse(`${value}T00:00:00Z`));

export const getPrivacyEffectiveDate = (
    runtimeValue = typeof window !== 'undefined' ? window.env?.REACT_APP_PRIVACY_EFFECTIVE_DATE : undefined,
    buildValue = process.env.REACT_APP_PRIVACY_EFFECTIVE_DATE,
) => [runtimeValue, buildValue].find(isValidDate) || DEFAULT_PRIVACY_EFFECTIVE_DATE;

// Formats the date as written (no timezone shift), e.g. "September 26, 2026".
export const formatEffectiveDate = isoDate => new Date(`${isoDate}T00:00:00Z`).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
});
